"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var timer_internal_1 = require("./timer-internal");
exports.clearImmediate = timer_internal_1.internalClearImmediate;
exports.clearInterval = timer_internal_1.internalClearInterval;
exports.clearTimeout = timer_internal_1.internalClearTimeout;
exports.setImmediate = timer_internal_1.internalSetImmediate;
exports.setInterval = timer_internal_1.internalSetInterval;
exports.setTimeout = timer_internal_1.internalSetTimeout;
